import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/types";
import SbuxStyledTableRow from "../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxStyledTableCell from "../../../../components/SbuxTable/SbuxStyledTableCell";
import SbuxContentCopy from "../../../../components/SbuxContentCopy";
import {
  isPhoneNumber,
  phoneNumberDetail,
} from "../../../../utils/phoneNumber";
import {
  dialByPhoneNumber,
  transferToEndpoint,
} from "../../../content/common/agentCall";
import Link from "@mui/material/Link";
import { getCcpValidationButtonStatusSelector } from "../../../../selectors/ccpSelector";

interface QuickConnectsRowProps {
  row: Record<string, unknown>;
}

const QuickConnectsRow = ({ row }: QuickConnectsRowProps) => {
  const dispatch = useAppDispatch();
  const ccpValidationButtonStatus = useAppSelector(
    getCcpValidationButtonStatusSelector,
  );

  const handleDialPhoneNumber = useCallback(
    (phoneNumber: string) => {
      dialByPhoneNumber(phoneNumber, null, dispatch);
    },
    [dispatch],
  );

  const handleTransfer = useCallback(
    (endpoint: Record<string, unknown>) =>
      transferToEndpoint(endpoint as unknown as connect.Endpoint, dispatch),
    [dispatch],
  );

  const linkRenderer = () => {
    return (
      <div>
        <Link
          component="button"
          disabled={ccpValidationButtonStatus}
          onClick={() =>
            row.type === "phone_number"
              ? handleDialPhoneNumber(row.phoneNumber as string)
              : handleTransfer(row)
          }
        >
          {row.phoneNumber ? String(row.phoneNumber) : "Click-to-Dial"}
        </Link>
        {isPhoneNumber(row.phoneNumber as string) && (
          <SbuxContentCopy
            content={
              phoneNumberDetail(row.phoneNumber as string)?.phoneNumber ?? ""
            }
          />
        )}
      </div>
    );
  };

  return (
    <>
      <SbuxStyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <SbuxStyledTableCell>{String(row.name ?? "")}</SbuxStyledTableCell>
        <SbuxStyledTableCell>{linkRenderer()}</SbuxStyledTableCell>
      </SbuxStyledTableRow>
    </>
  );
};

export default QuickConnectsRow;
